import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
    Card,
    CardActionArea,
    CardContent,
    Box,
    Typography,
    CardHeader,
    Tooltip,
} from "@mui/material";

import { connect } from "react-redux";
import rmsActions from "../../../../actions/rmsActions";
import { getAppraisees, getRmsAppCode } from "../../../../reducers";

import RMSAvatar from "../RMSAvatar";

const MyAppraiseesCard = ({ appraisees, getAppraisees, appCode }) => {
    useEffect(() => {
        getAppraisees(appCode);
    }, [getAppraisees, appCode]);

    return (
        <Card className="card">
            <CardActionArea
                component={Link}
                to={"/rms/appraisees"}
                centerRipple={false}
            >
                <CardHeader
                    disableTypography={true}
                    avatar={
                        <Tooltip title="View your appraisees" arrow>
                            <RMSAvatar type={"appraisee"} />
                        </Tooltip>
                    }
                    title={
                        <Typography
                            component="h2"
                            className="card-header-title"
                        >
                            My Appraisees
                        </Typography>
                    }
                    subheader={
                        <Typography
                            component="span"
                            className="card-header-subtitle"
                        >
                            {appraisees?.length ?? 0} appraisees
                        </Typography>
                    }
                />
            </CardActionArea>
            <CardContent>
                <Box className="card-content"></Box>
            </CardContent>
        </Card>
    );
};

const mapStateToProps = (state) => ({
    appraisees: getAppraisees(state),
    appCode: getRmsAppCode(state),
});

export default connect(mapStateToProps, {
    getAppraisees: rmsActions.getAppraisees,
})(MyAppraiseesCard);
